import { PROVIDER_PRIMARY_CARE_TEMPLATE_ID, PROVIDER_TYPE_CMG_TEMPLATE_ID } from 'lib/constants';
import { SpecialtyItem } from '../../../types/provider-items';
import { Item } from '@sitecore-jss/sitecore-jss-nextjs';

// Return a list of public-facing provider specialties, applying business logic
export const getUserFacingProviderSpecialties = (
  specialties: SpecialtyItem[] | undefined,
  providerType: Item | undefined
): SpecialtyItem[] => {
  const validSpecialties = (specialties || []) as SpecialtyItem[];
  return validSpecialties?.filter((specialty) => {
    // Only show primary care for CMG providers
    if (specialty?.id === PROVIDER_PRIMARY_CARE_TEMPLATE_ID) {
      return providerType?.id === PROVIDER_TYPE_CMG_TEMPLATE_ID;
    }
    return true;
  });
};
